import $ from 'jquery';

$(function () {
  var rewardId;

  var getEmployeeIds = function () {
    var ids = [];
    $('td.js-employee-cell').each(function () {
      ids.push($(this).data('employee'));
    });
    return ids;
  };

  var pollReport = function (cacheKey) {
    window.setTimeout(function () {
      $.ajax({
        url: '/rewards_report_status',
        data: { cache_key: cacheKey },
        success: function (data) {
          if (data.waiting) {
            pollReport(cacheKey);
          } else {
            var button = $('.js-reload-progress-button');
            button.attr('disabled', false);
            button.removeClass('btn-secondary').addClass('btn-primary');
            button.text('Ready! Click to show.');
            $('.js-reload-progress-button').click(function () {
              window.location.href =
                window.location.pathname + '?cache_key=' + cacheKey;
            });
          }
        },
      });
    }, 2000);
  };

  if ($('.rewards-report table').length) {
    var reportTable = $('.rewards-report-table').data();
    if (!reportTable.progressGenerated) {
      pollReport(reportTable.cacheKey);
    }

    $('.js-fulfill-rewards-button').click(function () {
      rewardId = $(this).data('reward');
      $('.js-fulfill-all-modal[data-reward="' + rewardId + '"]').modal('show');
    });

    $('.js-fulfill-all-confirm-button').click(function () {
      $('.rewards-report').addClass('ajax-loading');
      $.ajax({
        type: 'put',
        url: 'fulfill_employee_earned_rewards',
        data: { employees: getEmployeeIds(), fulfill: true, reward: rewardId },
        success: function () {
          $('.js-earned-cell[data-rewardId=' + rewardId + ']').html(0);
          const button = $(
            `.js-fulfill-rewards-button[data-reward=${rewardId}]`,
          );
          const buttonLabel = button.data('snappyEnabled')
            ? 'Fulfilling...'
            : 'Fulfilled';

          button.text(buttonLabel).attr('disabled', true);
        },
        complete: function () {
          $('.rewards-report').removeClass('ajax-loading');
        },
      });
      $('.js-fulfill-all-modal[data-reward="' + rewardId + '"]').modal('hide');
    });

    $.fn.dataTable.ext.search.push(function (settings, data) {
      var checkbox = $('.show-deactivated-checkbox');
      var showDeactivated = checkbox.prop('checked');

      if (showDeactivated) {
        return true;
      }
      return data[data.length - 1] === 'true'; // the last column is "active? true/false"
    });

    $('.show-deactivated-checkbox').change(function () {
      $('.rewards-report-table').DataTable().draw();
    });

    $('.rewards-report-table').DataTable().draw();
  }
});
